import { render, staticRenderFns } from "./CustomerWhatsapp.vue?vue&type=template&id=5148a038"
import script from "./CustomerWhatsapp.vue?vue&type=script&lang=js"
export * from "./CustomerWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports